<template>
    <div id="FQ">
        <div class="title">QA</div>
        <el-collapse v-model="activeNames" accordion class="collapse_box">
            <el-collapse-item title="How do I apply for a loan?" name="1">
                <div>Download the Zada ​​Cash app, register using your mobile number, fill out your profile including the required personal information and funding account, then click Apply!</div>
            </el-collapse-item>
            <el-collapse-item title="What materials are required for the application?" name="2">
                <div>You need to provide an ID card, fill in your personal information, contact person, etc., and wait for the approval result after submission.</div>
            </el-collapse-item>
            <el-collapse-item title="How long does it take to get a loan?" name="3">
                <div>After you submit your information, we will review it immediately and the loan will usually be disbursed within 10 minutes.</div>
            </el-collapse-item>
            <el-collapse-item title="Where can I receive money?" name="4">
                <div>Once approved, we will deposit the money into the e-wallet or bank account you provide.</div>
            </el-collapse-item>
            <el-collapse-item title="How to repay?" name="5">
                <div>You can use the repayment code to complete the repayment through these channels (7-Eleven, G-Cash, RD Pawnshop, M. Lhuillier).</div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeNames: '1'
        };
    },
    created() {
    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
#FQ {
    width: calc(100% - 390px);
    margin: 200px auto 0;
    .title {
        font-weight: 500;
        font-size: 60px;
        line-height: 78px;
        text-align: center;
        font-family: 'Lexend_Medium';
    }
    .collapse_box {
        margin-top: 86px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FQ.vue